var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVoucherIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.333008 0.333496H25.6663V4.21338C24.0277 4.21338 22.6994 5.54174 22.6994 7.18034C22.6994 8.81895 24.0277 10.1473 25.6663 10.1473V14.0272H0.333008V10.1473C1.97161 10.1473 3.29997 8.81895 3.29997 7.18034C3.29997 5.54174 1.97161 4.21338 0.333008 4.21338V0.333496Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.875 7.63091V5.198H14.522V7.63091H20.875Z",
    fill: "#E53324"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0674 5.1983V2.76538H9.63447V5.1983H12.0674Z",
    fill: "#E53324"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.875 2.76665V0.33374L14.522 0.33374V2.76665L20.875 2.76665Z",
    fill: "#E53324"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4769 7.67432H12.0439V14.0273H14.4769V7.67432Z",
    fill: "#E53324"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6126 7.67432H7.17969V14.0273H9.6126V7.67432Z",
    fill: "#E53324"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoucherIcon);
export default __webpack_public_path__ + "static/media/voucher-icon.f27700636ba82213594294ef02a48778.svg";
export { ForwardRef as ReactComponent };